<template>
	<div
		class="shape-authoring-vertex"
		:splitter="splitter"
		:controls="controls"
	>
		<div
			class="vertex"
			@mousedown.prevent="$emit('mousedown')"
		/>
		<hr v-show="controls">
		<div class="controls bg-body">
			<b-input-group prepend="Lng" size="sm">
				<b-form-input
					v-model="cartographicVertex.longitude"
					step=".00001"
					type="number"
					@change="update()"
				/>
			</b-input-group>
			<b-input-group prepend="Lat" size="sm">
				<b-form-input
					v-model="cartographicVertex.latitude"
					step=".00001"
					type="number"
					@change="update()"
				/>
			</b-input-group>
			<b-button class="w-100" variant="dark" @click="$emit('delete')">
				{{ $t("shape-authoring-workflow.vertex-controls.remove") }}
			</b-button>
			<b-button
				v-show="closeable"
				class="w-100"
				variant="secondary"
				@click="$emit('close-loop')"
			>
				{{ $t("shape-authoring-workflow.vertex-controls.close-loop") }}
			</b-button>
		</div>
	</div>
</template>

<script>
import { Cartographic, Math as CesiumMath } from 'cesium';

export default {
	name: 'ShapeAuthoringVertex',
	props: {
		/**
		 * Cesium Carthesian3 representation of this vertex
		 */
		vertex: {
			type: Object,
			default: null,
		},
		/**
		 * Renders this vertex as a line splitting vertex
		 */
		splitter: {
			type: Boolean,
			default: false,
		},
		/**
		 * Show numeric vertex controls
		 */
		controls: {
			type: Boolean,
			default: false,
		},
		/**
		 * Show loop closing button
		 */
		closeable: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		/**
		 * Cartographic(=latitude,longitude) vertex representation
		 */
		cartographicVertex: {
			get() {
				if (!this.vertex) return Cartographic.ZERO;
				const cart = Cartographic.fromCartesian(this.vertex);
				cart.latitude *= CesiumMath.DEGREES_PER_RADIAN;
				cart.longitude *= CesiumMath.DEGREES_PER_RADIAN;
				return cart;
			},
		},
	},
	mounted() {},
	methods: {
		update() {
			const cart = this.cartographicVertex;
			cart.latitude /= CesiumMath.DEGREES_PER_RADIAN;
			cart.longitude /= CesiumMath.DEGREES_PER_RADIAN;
			/**
			 * Emits when the user updates the cartographic coordinates
			 * @property {Cartesian3} vertex
			 */
			this.$emit('update', Cartographic.toCartesian(cart));
		},
	},
};
</script>

<style lang="scss" scoped>
.shape-authoring-vertex {
	transition: none;
	display: inline-block;
	position: absolute;
	z-index: 5;
	.vertex {
		border-radius: 100rem;
		background: #fff;
		width: 0.7rem;
		height: 0.7rem;
		transform: translate(-50%, -50%);
		cursor: pointer;
	}
	.vertex {
		box-shadow: 0 0 0.5rem #000;
	}
	.controls {
		display: none;
		border: 1px solid #fff;
		position: absolute;
		top: 0;
		left: 3rem;
		width: 14rem;
		transform: translateY(-50%);
	}
	hr {
		pointer-events: none;
		position: absolute;
		width: 3rem;
		height: 2px;
		background: #fff;
		border: none;
		top: 0;
		margin: 0;
	}
	&[splitter] .vertex {
		background: rgba(255, 255, 255, 0.2);
		border: 1px solid #fff;
	}
	&[controls] {
		z-index: 50;
		.controls {
			display: block;
		}
	}
}
::v-deep {
	.input-group-prepend .input-group-text {
		width: 3rem;
	}
}
</style>
